<template>
  <div class="content">
    <section class="signup-form signup">
      <div class="container">
        <div class="row form-row">
          <div class="col-sm-6">
            <div class="form-left">
              <div class="inner-logo"><img src="../assets/images/logo.png" alt="" /></div>
              <div class="form-pic hidden-xs">
                <img src="../assets/images/formpic.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-main">
              <h2 class="">用户登录 <span>>></span></h2>
              <form method="post">
                <div class="row-box">
                  <div class="col-box">
                    <p>
                      <input
                        type="text"
                        name="phone_number"
                        maxlength="14"
                        placeholder="请输入账号"
                        class="form-controls"
                        v-model="phone"
                      />
                    </p>
                  </div>
                </div>
                <div class="row-box">
                  <div class="col-box">
                    <p>
                      <input
                        type="password"
                        @keydown="keyDownLogin()"
                        maxlength="60"
                        placeholder="请输入登录密码"
                        class="form-controls"
                        v-model="password"
                      />
                    </p>
                  </div>
                </div>
                <div class="login--form--submit">
                  <button @click="login" class="btn btn-primary" type="button">
                    登录
                  </button>
                </div>
                <!-- <div class="row-link">
                  <router-link class="pull-left" to="/register">注册</router-link>

                  <router-link class="pull-right" :to="{path:'ForgetPassword'}">忘记密码</router-link>
                </div> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
var self;
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      phone: "",
      password: "",
    };
  },
  mounted() {
    self = this;
  },
  methods: {
    login: function () {
      if (
        this.phone == null ||
        this.phone == "" ||
        this.password == null ||
        this.password == ""
      ) {
        this.errToastr("账号或密码不能为空");
        return;
      }

      this.$http
        .post(this._Global.HTTP_SERVER + "/login", {
          account: this.phone,
          password: this.password,
        })
        .then((response) => {
          self.respDataHandle(response.body, function (respData) {
            self.setToken(respData);
            self.$router.push({ name: "SuperSignApps" });
          });
        });
    },
    keyDownLogin: function (e) {
      var evt = window.event || e;
      if (evt.keyCode == 13) {
        //回车事件
        this.login();
      }
    },
  },
};
</script>

<style scoped>
button {
  width: 6em;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue